import { Navigate } from 'react-router-dom';
import { useAuth } from '@auth';
import { routes } from '@/shared/routes';

interface Props {
  children: React.ReactNode;
  fallback?: string;
}

export default function ProtectedRoute({ children, fallback = routes.app.signin }: Props) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
